// extracted by mini-css-extract-plugin
export default {"lobby":"hG_hH","lobby_isFull":"hG_hI","lobby_isAndroid":"hG_hJ","lobby__closeButton":"hG_hK","lobby__iframeDocument":"hG_hL"};